'use client'

import { useTranslations } from 'next-intl'
import { Card } from '@repo/web-ui/components/card'
import { CardTitle } from '@repo/web-ui/components/card/card-title'
import { CardContent } from '@repo/web-ui/components/card/card-content'

import { PostAProjectButton } from './post-a-project-button'
import { Typography } from '@repo/design-system-cf/components/typography'
export const ShareCreationContent = () => {
  const t = useTranslations('prod.product_description_page.share_creation')

  return (
    <Card variant="elevated">
      <CardTitle>{t('banner.title')}</CardTitle>
      <CardContent className="flex flex-wrap justify-between gap-4 lg:flex-nowrap w-full">
        <Typography variant={'body-02'}>{t('banner.content')}</Typography>
        <div>
          <PostAProjectButton />
        </div>
      </CardContent>
    </Card>
  )
}
